import { createContext, useContext } from 'react';

/**
 * Lets a tile's view colour the whole tile, title row included, as the legacy light tile did while
 * a tap was being carried out. `TileView` provides it; undefined restores the tile's background.
 */
export const TileHighlightContext = createContext<(color: string | undefined) => void>(() => {});

export function useTileHighlight() : (color: string | undefined) => void {
    return useContext(TileHighlightContext);
}
